import './StoryTelling.css';
import React, { useRef, useState } from 'react';
import StoryTellingModal from './component/StoryTellingModal';
import { useTranslation } from 'react-i18next';
import { Button } from 'primereact/button';

function StoryTelling(props) {
  const { t } = useTranslation();

  const restoreElement = useRef();
  const [active, setActive] = useState(false);

  const handleClick = () => {
    setActive(active => !active);
  };

  return (
    <div id="StoryTelling" className="StoryTelling">
      <Button
        className='HorizontalButton'
        type='button'
        alt={t('storyTelling.alt')}
        title={t('storyTelling.title')}
        onClick={handleClick}
        ref={restoreElement}
        icon="pi pi-chart-line"
      >
      
      </Button>
      <StoryTellingModal map={props.map} active={active} callback={setActive} />
    </div>
  );
}

export default StoryTelling;
